import { type ReactNode } from "react";

import { Stack } from "@mui/material";

type Props = {
  bigWidth: boolean;
  children: ReactNode;
};

export const AvaCaseIQFooter = ({ bigWidth, children }: Props) => (
  <Stack
    p={1}
    alignItems={bigWidth ? "center" : "flex-end"}
    sx={{ borderTop: "1px solid", borderColor: "divider", backgroundColor: "background.paper" }}
  >
    <Stack width={bigWidth ? 980 : "auto"} alignItems="center" direction="row" justifyContent="flex-end">
      {children}
    </Stack>
  </Stack>
);
